module.exports = __webpack_public_path__ + "img/user-recruiting-profile.08ac26f4.svg";